







































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import PdMonitorChart from "../../chart.vue";
import DynamicColumnSelect from "../../dynamicColumnSelect.vue";
import {
  QueryPdMonitorNutritionChartData,
  GetPdAssessNutritionListForMonitor
} from "@/api/pdOutPatient/pdComprehensiveEvaluation/pdAssessNutrition";
@Component({
  components: {
    PdMonitorChart,
    DynamicColumnSelect
  }
})
export default class PdMonitorNutri extends AbpBase {
  @Prop() patient: any;
  currentType: string = "0";
  chartData: any = null;
  showDyanmicColumnSelect: boolean = false;
  selectedColumns: any = [];
  data: any = [];
  buttons: any = [
    {
      type: "0",
      buttonText: "NRS2002",
      onClick: (type: string) => {
        this.handleClick(type);
      }
    }
  ];

  columns = [
    {
      title: "NRS2002评分",
      key: "nrs",
      width: 200
    },
    {
      title: "SGA",
      key: "sga",
      width: 200
    },
    {
      title: "PEW",
      key: "pew",
      width: 200
    }
  ];

  @Watch("patient", { immediate: true, deep: true })
  onPatientChanged() {
    this.selectedColumns = JSON.parse(JSON.stringify(this.columns)); //此处用数组拷贝的方式会出现错误“You may have an infinite update loop in watcher with expression "columns"”，故采用json序列化的方式拷贝数组，且render函数无效，需另外编写api数据接口
    this.insertAssessTime();
    if (this.patient.pD_Patient_ID) {
      this.handleClick("0");
      this.getData();
    }
  }

  //在第一列前面插入评估日期
  insertAssessTime() {
    this.selectedColumns.splice(0, 0, {
      title: "日期",
      key: "assessTime",
      minWidth: 120,
      render: (h: any, p: any) => {
        return h("div", {}, this.formatDate(p.row.assessTime));
      }
    });
  }

  async getData() {
    let res = await GetPdAssessNutritionListForMonitor(
      this.patient.pD_Patient_ID
    );
    this.data = res.objects;
  }

  handleDyanmicColumnSelectOk() {
    let res = this.$refs.DynamicColumnSelect.onSubmit();
    this.selectedColumns = JSON.parse(JSON.stringify(res));
    this.insertAssessTime();
  }

  async handleClick(type: string) {
    this.currentType = type;
    let payload = {
      pD_Patient_ID: this.patient.pD_Patient_ID,
      type: type
    };
    let res = await QueryPdMonitorNutritionChartData(payload);
    this.chartData = res.objects;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdMonitor/pdMonitorIndex/parts/pdMonitorNutri/index.vue